import { IS_DEVELOPMENT_ENV } from '../AppConfig';
import { EBotType, EOptionAction, OptionProps } from '../types';

export const MIXPANEL_EVENTS = {
  BOT_MENU_CLICKED: 'BOT_MENU_CLICKED',
  BOT_CLOSED: 'BOT_CLOSED',
  BOT_LOADED: 'BOT_LOADED',
  BOT_ERROR: 'BOT_ERROR',
  IMTC_RAISE_A_TICKET_CLICKED: 'employee-help-center-imtc-raise-a-ticket-clicked',
  RAISE_A_TICKET_CLICKED: 'employee-help-center-raise-a-ticket-clicked'
};

export const ALLOWED_PARENT_ORIGINS = IS_DEVELOPMENT_ENV
  ? ['http://localhost:3000', 'http://localhost:5173','http://localhost:5174', 'http://localhost:3001']
  : [
      'https://app.plumhq.com',
      'https://staging.plumhq.com',
      'https://staging-claims.plumhq.com',
      'https://plum-git-mayank-policygpt-bugfix.preview.plumhq.com',
      'https://my.plumhq.com',
      'https://my-staging.plumhq.com',
      'https://staging-personal.plumhq.com',
      'https://personal.plumhq.com'
    ];

export const rtlInitialOptions: OptionProps[] = [
  {
    title: 'How does it work?',
    actionType: EOptionAction.BOT_BUTTON,
  },
  {
    title: 'Why is it right for me?',
    actionType: EOptionAction.BOT_BUTTON,
  },
  {
    title: 'Why buy now?',
    actionType: EOptionAction.BOT_BUTTON,
  },
  {
    title: `What's covered?`,
    actionType: EOptionAction.BOT_BUTTON,
  },
];

export const botWithContext = new Set<EBotType>([
  EBotType.CASHLESS_GPT_V2,
  EBotType.CLAIMS_BOT,
  EBotType.REIMBURSEMENT_CLAIMS_BOT,
  EBotType.HEALTH_CHECKUP_BOT,
  EBotType.HEALTH_CHECKUP_SUPPORT_BOT,
  EBotType.TELEHEALTH_BOT,
  EBotType.HEALTH_ID_BOT,
  EBotType.MANAGE_DEPENDENT_BOT,
  EBotType.TELEHEALTH_SUPPORT_BOT,
  EBotType.CASHLESS_SUPPORT_BOT,
  EBotType.CULT_SUPPORT_BOT
]);

export const v3Bots = new Set<EBotType>([
  EBotType.HEALTH_CHECKUP_SUPPORT_BOT,
  EBotType.REIMBURSEMENT_CLAIMS_BOT,
  EBotType.HEALTH_ID_BOT,
  EBotType.MANAGE_DEPENDENT_BOT,
  EBotType.TELEHEALTH_SUPPORT_BOT,
  EBotType.CASHLESS_SUPPORT_BOT,
  EBotType.CULT_SUPPORT_BOT,
  EBotType.POLICYGPTV2,
]);

export const CALENDLY_URL = 'https://calendly.com/d/cp2w-j5c-7jm/1-1-consultations-with-our-insurance-expert';

export const COOKIE_CONFIG = {
  domain: IS_DEVELOPMENT_ENV ? 'localhost' : '.plumhq.com',
  path: '/',
}

export const APP_DEEPLINK_WEBOUTSIDE_URL = 'https://deeplink.plumhq.com/weboutside?screen=weboutside&id='

export const CUSTOMER_CARE_NUMBER = '180030911911'
